export const trims = ({ trims }) => trims.byId;
